export default __webpack_public_path__ + "static/media/ams.c600f42a.jpg";